module.exports = __webpack_public_path__ + "img/business6.4c39c4f3.png";